export default __webpack_public_path__ + "static/media/ecologic-leaf-svgrepo-com.5d3118e1.svg";